<template>
  <div class="pix-member-circle-row">
    <pix-member-circle v-for="(name, index) in initialNames" :key="`${name}${index}`" :name="name" @click="emitClick(name)" :clickable="clickable" />
    <div v-if="exceedsNamesLimit" @mouseenter.self="showMenu = true" @mouseleave.self="showMenu = false" class="pix-member-circle-row__wrapper">
      <pix-member-circle dummy :dummy-text="`+${exceedingNames.length}`" :clickable="clickable" />
      <div class="pix-member-circle-row__wrapper__menu" v-if="showMenu">
        <ul>
          <li
            v-for="(exceedingName, exceedingNameIndex) in exceedingNames"
            :key="`${exceedingName}${exceedingNameIndex}`"
            :class="`
                            pix-member-circle-row__wrapper__menu__item
                            ${clickable ? 'pix-member-circle-row__wrapper__menu__item--clickable' : ''}
                        `"
            :title="getFormattedName(exceedingName)"
            @click="emitClick(exceedingName)"
          >
            <span>{{ getFormattedName(exceedingName) }}</span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import pixMemberCircle from './pixMemberCircle.vue';
import _ from 'lodash';
export default {
  name: 'pix-member-circle-row',

  components: { pixMemberCircle },

  data() {
    return {
      showMenu: false,
    };
  },

  props: {
    names: { type: Array, default: () => [] },
    maxLength: { type: Number, default: 4 },
    clickable: { type: Boolean, default: false },
  },

  computed: {
    initialNames() {
      if (this.exceedsNamesLimit) {
        return this.names.slice(0, this.maxLength - 1);
      }
      return this.names;
    },
    exceedsNamesLimit() {
      if (this.names) {
        return this.names.length > this.maxLength - 1;
      } else {
        return null;
      }
    },
    exceedingNames() {
      return [...this.names].splice(this.maxLength - 1, this.names.length - this.maxLength + 1);
    },
  },

  methods: {
    emitClick(name) {
      this.$emit('click', name);
    },

    getFormattedName(name) {
      const separatedByDot = name?.split('@')[0]?.split('.');
      return `${_.capitalize(separatedByDot[0])} ${_.capitalize(separatedByDot[1])}`;
    },
  },
};
</script>

<style scoped>
.pix-member-circle-row {
  display: flex;
  place-content: flex-start;
  align-items: center;
  margin-right: 6px;
}

.pix-member-circle-row >>> .pix-member-circle:not(:first-child),
.pix-member-circle-row__wrapper >>> .pix-member-circle {
  margin-left: -4px;
}

.pix-member-circle-row__wrapper {
  position: relative;
}

.pix-member-circle-row__wrapper__menu {
  background: white;
  border: solid 1px #ebecec;
  position: absolute;
  top: 0px;
  right: -150px;
  margin-left: 10px;
  padding: 10px;
  width: 150px;
  z-index: 2;
}

.pix-member-circle-row__wrapper__menu ul {
  margin: 0;
  padding: 0;
  list-style-type: none;
  display: flex;
  flex-direction: column;
}

.pix-member-circle-row__wrapper__menu ul li {
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.pix-member-circle-row__wrapper__menu__item--clickable {
  font-weight: bold;
  cursor: pointer;
}
</style>
